
import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormInputFile from "Common/Custom/FormInputFile";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormTextarea from "Common/Custom/FormTextarea";
import Switch from "Common/Custom/Switch";
import FormSelect from "Common/Custom/FormSelect";
import { getSelectOptions } from "utils/optionHelper";
import CheckboxGroup from "./CheckboxGroup";

const EditHallRoomTypeForm = ({
  values,
  errors,
  handleChange,
  handleFileChange,
  handleSubmit,
  loading,
  imagePreview,
  formdata,
  SeatplanOptions,
  facilityOptions,
  setValues
}) => {
  const optionConfig = {
    seatplan_id: {
      list: SeatplanOptions,
      valueKey: "id",
      labelKey: "plan_name"
    }
  };

  return (
    <PageBody onSubmit={handleSubmit} headerchildren={
      <HeadingOne>Edit Hall Room Type</HeadingOne>
    }>
      {formdata.map((field) => {

        if (field.type === "image") {
          return (
            <FormInputFile
              key={field.name}
              field={field}
              handleChange={handleFileChange}
              error={errors[field.name]}
              imagePreview={imagePreview}
            />
          );
        }

        if (field.type === "switch") {
          return (
            <Switch
              values={values[field.name]}
              handleChange={handleChange}
              error={errors[field.name]}
              field={field}
              ValueOne="1"
              ValueTwo="0"
              LabelOne="Active"
              LabelTwo="Inactive"
            />
          );
        }

        if (field.type === "textarea") {
          return (
            <FormTextarea
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              error={errors[field.name]}
            />
          );
        }

        if (field.type === "select") {
          return (
            <FormSelect
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              options={getSelectOptions(field.name, optionConfig)}
              error={errors[field.name]}
            />
          );
        }

        if (field.type === "checkbox") {
          return (
            <CheckboxGroup
              key={field.name}
              field={field}
              values={values}
              setValues={setValues}
              facilityOptions={facilityOptions}
            />
          );
        }

        // default text input
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label="Update"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditHallRoomTypeForm;
